<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Edit Academic Calendar">
      <v-card flat class="px-2">
        <form autocomplete="off" @submit.prevent="saveAcademicCalendar">
          <v-row>
            <v-col cols="12" md="3" v-if="academicCalendarData.franchiseeAcademicYear">
              <label class="font-weight-medium body-2">
                Academic Year
              </label>
              <v-text-field class="my-0 py-1" v-model="academicCalendarData.franchiseeAcademicYear.academicYear"
                readonly></v-text-field>
            </v-col>
            <v-col cols="12" md="3" v-if="academicCalendarData.curriculumBusinessProgramMap">
              <label class="font-weight-medium body-2">
                Business
              </label>
              <v-text-field class="my-0 py-1"
                v-model="academicCalendarData.curriculumBusinessProgramMap.curriculumBusiness.name"
                readonly></v-text-field>
            </v-col>
            <v-col cols="12" md="3" v-if="academicCalendarData.zone">
              <label class="font-weight-medium body-2">
                Zone
              </label>
              <v-text-field class="my-0 py-1" v-model="academicCalendarData.zone.name" readonly></v-text-field>
            </v-col>
            <v-col cols="12" md="3" v-if="academicCalendarData.franchisee">
              <label class="font-weight-medium body-2">
                Center
              </label>
              <v-text-field class="my-0 py-1" v-model="academicCalendarData.franchisee.companyName"
                readonly></v-text-field>
            </v-col>
            <v-row align="center" justify="center">
              <v-col cols="2">
                <v-dialog ref="dialog1" v-model="modal" :return-value.sync="startDate" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field label="From Month*" v-model="startDate" prepend-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" scrollable type='month' :min="minDate" :max="maxDate">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.dialog1.save(startDate), enableButton()">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="2">
                <v-dialog ref="dialog" v-model="modal1" :return-value.sync="toDate" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field label="To Month*" v-model="toDate" prepend-icon="mdi-calendar" readonly v-bind="attrs"
                      v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="toDate" scrollable type='month' :min="minDate" :max="maxDate">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal1 = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(toDate), enableButton()">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col cols="3">
                <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" medium @click="getHolidayName"
                  :disabled=disabled>Start Calender Creation</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="auto" v-for="(eventType, index) in evenTypeList" :key="index">
                <v-btn :color="eventType.eventColorCode" medium>{{ eventType.eventName
                }}</v-btn>
              </v-col>
            </v-row>
            <v-col cols="12" md="12" lg="12" sm="12">
              <v-card class="pa-1 elevation-0">
                <v-row style="border:solid 1px #000;" no-gutters>
                  <v-slide-group class="pa-4" active-class="success" show-arrows>
                    <v-slide-item v-for="(calenderObj, index) in academicCalenderArray" :key=index v-slot="{}">
                      <v-card width="100%">
                        <div class="table-border-right" style="width:250px;">
                          <!--Start Month Header-->
                          <v-row class="table-border" no-gutters>
                            <v-col cols="12" md="12" lg="12" sm="12" xs="12">
                              <v-toolbar elevation="0" height="30px" style="background-color: #5d58ef">
                                <div class="table-header">{{ calenderObj.monthName }}</div>
                              </v-toolbar>
                            </v-col>
                          </v-row>
                          <!--End Month Header-->
                          <!--Start Header Design-->
                          <v-row class="table-border" no-gutters>
                            <v-col v-for="(headers, headerIndex) in calenderObj.headers" :key="`${headerIndex}_${index}`"
                              class="d-flex justify-center table-border-right" cols="12"
                              :md="(headers === 'activity') ? '6' : '3'" :lg="(headers === 'activity') ? '6' : '3'"
                              :sm="(headers === 'activity') ? '6' : '3'">
                              {{ headers }}
                            </v-col>
                          </v-row>
                          <!--End Header Design-->
                          <!--Start Day Loop Design-->
                          <v-row v-for="(day, daysIndex) in calenderObj.daysInMonth" :key="`${daysIndex}_${day}`"
                            class="table-border" :class="{ 'grey-bg': isWeekend(day, calenderObj.monthName) }" no-gutters>
                            <v-col class="d-flex justify-center table-border-right" cols="12" md="3" lg="3" sm="3">{{ day
                            }}</v-col>
                            <v-col class="d-flex justify-center table-border-right" cols="12" md="3" lg="3" sm="3">{{
                              getDayFromMonthYear(day, calenderObj.monthName) }}</v-col>
                            <v-tooltip bottom open-delay="400">
                              <template v-slot:activator="{ on, attrs }">
                                <v-col class="d-flex justify-center" @dblclick="openCalendar(day, calenderObj.monthName)"
                                  style="cursor:pointer;"
                                  :style="`background-color:${getActivityName(day, calenderObj.monthName).activityColor}`"
                                  cols="12" md="6" lg="6" sm="6" xs="5" v-bind="attrs" v-on="on">{{ getActivityName(day,
                                    calenderObj.monthName).activityName }}</v-col>
                              </template>
                              <span>Double Click to Edit!</span>
                            </v-tooltip>
                          </v-row>
                          <!--End Day Loop Design-->
                        </div>
                      </v-card>
                    </v-slide-item>
                  </v-slide-group>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </form>
      </v-card>
    </material-card>
    <v-dialog v-model="dialog" max-width="100%" max-height="700">
      <v-date-picker multiple v-model="selectedDates" :width="760" :height="700" @input="handleDateSelection($event)">
        <div>
          <v-row>
            <v-col cols="12" sm="12">
              <h3>Selected Dates:</h3>
            </v-col>
            <v-col v-for="(item, key) in selectedDates" :key="`selected-date_${key}`" class="selected-date" cols="12"
              md="12" lg="12" xs="12" sm="12">
              <v-row>
                <v-col cols="12" md="1" lg="1" sm="1" xs="12">
                  <span>{{ saveAllHolidayListName[item].date }}</span>
                </v-col>
                <v-col cols="12" md="6" lg="6" sm="6" xs="12">
                  <v-combobox v-model="saveAllHolidayListName[item].selectedHoliday"
                    placeholder="Press enter after adding" label="Enter Holiday Name" class="my-0 py-1" multiple chips>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="item.name" @click="deleteIndividualHoliday(item.id, index)">
                        {{ item.name }}
                        <v-icon right>mdi-close</v-icon>
                      </v-chip>

                      <v-chip v-else>
                        {{ item }}
                        <v-icon right>mdi-close</v-icon>
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-col>
                <!-- <v-col cols="4" v-if="savedHolidayList[0]"> -->
                <v-col cols="12" md="4" lg="4" sm="4" xs="12">
                  <v-autocomplete v-model="saveAllHolidayListName[item].eventType" label="Select Event Type"
                    :items="evenTypeList" item-text="eventName" item-value="id"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="1" lg="1" sm="1" xs="12">
                  <v-card-actions>
                    <v-btn title="Delete Holiday" color="error" style="min-width: 0px; width: 45px;" small
                      @click="deleteEvent(saveAllHolidayListName[item].date, key)">
                      <v-icon left> mdi-trash-can </v-icon>
                    </v-btn>

                  </v-card-actions>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-card-actions class="justify-end">
                <v-btn color="success" @click="updateHoliday()">Save</v-btn>
                <v-btn align="right" color="error" @click="handleCancleButton()">Cancel</v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </div>
      </v-date-picker>
    </v-dialog>
  </v-container>
</template>
<script>
import MaterialCard from '@/components/template/MaterialCard'
import moment from 'moment'
import constants from '@/utils/constants'
export default {
  name: 'editAcademicCalendar',
  components: { MaterialCard },
  props: ['academicCalendarID'],
  data: function () {
    return {
      academicCalendarData: [],
      modal: false,
      modal1: false,
      startDate: '',
      toDate: '',
      disabled: true,
      academicCalenderArray: [],
      academicYears: '2023-2024',
      startYear: '',
      dialog: false,
      selectedDates: [],
      textFields: [],
      evenTypeList: [],
      date: '2023-08-06',
      savedHolidayList: [],
      selectedDatesWithSavedData: [],
      savedHolidayListByDate: {},
      holidayName: [],
      eventType: '',
      formattedDate: '',
      saveAllHolidayListName: {},
      isData: false,
      dateKey: null,
      updateHolidayID: null,
      deleteEventDate: null,
      deleteHolidayID: null,
      deleteHolidayIDs: []
    }
  },
  computed: {
    minDate () {
      if (this.academicCalendarData.length > 0) {
        let academicYear = this.academicCalendarData.franchiseeAcademicYear.academicYear
        if (academicYear) {
          const [startYear] = academicYear.split('-')
          return `${startYear}-01`
        }
      }
      return null
    },
    maxDate () {
      if (this.academicCalendarData.length > 0) {
        let academicYear = this.academicCalendarData.franchiseeAcademicYear.academicYear
        if (academicYear) {
          const [, endYear] = academicYear.split('-')
          return `${endYear}-12`
        }
      }
      return null
    }
  },
  watch: {

  },
  async created () {
    await this.getAcademicCalendarDetails()
    await this.getEventType()
    await this.getHolidayName()
  },
  methods: {
    async handleCancleButton () {
      this.deleteHolidayIDs = []
      this.deleteHolidayID = ''
      await this.getHolidayName()
      this.dialog = false
    },
    async handleDateSelection () {
      let dateKeys = Object.keys(this.saveAllHolidayListName)
      this.selectedDates.forEach(item => {
        if (dateKeys.indexOf(item) === -1) {
          this.saveAllHolidayListName[item] = {
            'date': item,
            'holidayList': [],
            'selectedHoliday': [],
            'eventType': null
          }
        }
      })
    },

    // ******Calendar Listing Starts********
    async openCalendar (date, month) {
      // Parse the input month and date using moment.js
      const parsedDate = moment(`${month} ${date}`, 'MMMM YYYY D')
      // Format the parsed date as "YYYY-MM-DD"
      this.formattedDate = parsedDate.format('YYYY-MM-DD')
      this.selectedDates = []
      await this.getSavedHolidays()
      this.textFields = []
      this.dialog = true
      this.getEventType()
      this.dateKey = Object.keys(this.saveAllHolidayListName)
    },
    isWeekend: function (dayNo, yearMonth) {
      dayNo = dayNo < 10 ? `0${dayNo}` : dayNo
      let date = `${dayNo} ${yearMonth}`
      let dayOfWeek = moment(date, 'DD MMMM YYYY').format('dddd')
      return dayOfWeek === 'Saturday' || dayOfWeek === 'Sunday'
    },
    getDayFromMonthYear: function (dayNo, yearMonth) {
      dayNo = dayNo < 10 ? `0${dayNo}` : dayNo
      let date = `${dayNo} ${yearMonth}`
      let getDay = moment(date, 'DD MMMM YYYY').format('dddd').substring(0, 3)
      return getDay
    },
    getAcademicCalendarDetails: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/academic-calendar/get-holiday-by-id/${this.academicCalendarID}`)
        this.academicCalendarData = data
        if (this.academicCalendarData) {
          let academicYear = this.academicCalendarData.franchiseeAcademicYear.academicYear
          if (academicYear) {
            const [startYear] = academicYear.split('-')
            this.startDate = `${startYear}-04`
            const [, endYear] = academicYear.split('-')
            this.toDate = `${endYear}-03`
          }
        }
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    getHolidayName: async function () {
      try {
        this.isLoading = true
        this.academicCalenderArray = []

        let startMonth = moment(this.startDate, 'YYYY-MM')
        let endMonth = moment(this.toDate, 'YYYY-MM')
        let getPayloadData = {
          academicYearID: this.academicCalendarData.academicYearID,
          franchiseeID: this.academicCalendarData.franchiseeID,
          zoneID: this.academicCalendarData.zoneID,
          businessID: this.academicCalendarData.businessProgramMapID,
          startMonth: this.startDate,
          endMonth: this.toDate
        }
        const { data } = await http.post(
          `${constants.API_URL}/api/academic-calender/get-holidays-list`, getPayloadData)
        this.holidayList = data

        if (endMonth.isBefore(startMonth)) {
          this.errMsg('End date must be greater than start date.')
          return false
        }

        endMonth = endMonth.add(1, 'month')
        while (startMonth.isBefore(endMonth)) {
          let monthActivityObj = {}
          monthActivityObj.monthName = moment(startMonth, 'YYYY-MM-DD').format('MMMM YYYY')
          monthActivityObj.headers = [
            'date',
            'day',
            'activity'
          ]
          let formattedMonth = moment(startMonth, 'YYYY-MM-DD').format('YYYY-MM')
          monthActivityObj.daysInMonth = moment(formattedMonth).daysInMonth()
          this.academicCalenderArray.push(monthActivityObj)
          startMonth.add(1, 'month')
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getActivityName: function (dayNo, yearMonth) {
      let activityColor = ''
      let activityName = ''
      let holidayNames = []
      dayNo = dayNo < 10 ? `0${dayNo}` : dayNo
      let date = `${dayNo} ${yearMonth}`
      let activityDate = moment(date, 'DD MMMM YYYY').format('YYYY-MM-DD')
      this.holidayList.forEach(item => {
        let itemDate = moment(item.date, 'YYYY-MM-DD').format('YYYY-MM-DD')
        if (itemDate === activityDate) {
          holidayNames.push(item.holidayname)
          activityColor = item.academicCalendarEvent.eventColorCode
        }
      })
      activityName = holidayNames.join(', ')
      return { activityName, activityColor }
    },
    // ******Calendar Listing Ends********

    // ******Calendar Edit Starts********
    getEventType: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/academic-calendar/get-event`
        )
        this.evenTypeList = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getSavedHolidays: async function () {
      try {
        this.isLoading = true
        this.saveAllHolidayListName = {}
        let eventDate = null
        let eventID = null
        let holidayData = []

        let url = `${constants.API_URL}/api/academic-calendar/get-holiday?date=${this.formattedDate}&academicYearID=${this.academicCalendarData.academicYearID}&zoneID=${this.academicCalendarData.zoneID}&businessProgramMapID=${this.academicCalendarData.businessProgramMapID}`
        if (this.academicCalendarData.franchiseeID !== null) {
          url += `&franchiseeID=${this.academicCalendarData.franchiseeID}`
        }
        const { data } = await http.get(url)
        this.savedHolidayList = data
        if (this.savedHolidayList.length > 0) {
          eventDate = this.savedHolidayList[0].date.split('T')[0]
          eventID = this.savedHolidayList[0].academicCalendarEvent.id
          this.savedHolidayList.forEach(item => {
            holidayData.push(
              {
                'id': item.id,
                'name': item.holidayname
              }
            )
          })
          this.selectedDates = []
          this.selectedDates.push(eventDate)
          this.saveAllHolidayListName[eventDate] = {
            'date': eventDate,
            'holidayList': holidayData,
            'selectedHoliday': holidayData,
            'eventType': eventID
          }
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    updateHoliday: async function () {
      try {
        this.isLoading = true
        let payload = {
          academicYearID: this.academicCalendarData.academicYearID,
          franchiseeID: this.academicCalendarData.franchiseeID,
          zoneID: this.academicCalendarData.zoneID,
          businessProgramMapID: this.academicCalendarData.businessProgramMapID,
          events: []
        }
        let holidayArray = []
        this.selectedDates.forEach(item => {
          this.saveAllHolidayListName[item].selectedHoliday.forEach(holidayItem => {
            holidayArray.push({
              id: holidayItem.id ? holidayItem.id : '',
              date: this.saveAllHolidayListName[item].date,
              holidayName: holidayItem.name ? holidayItem.name : holidayItem,
              eventTypeID: this.saveAllHolidayListName[item].eventType
            })
          })
        })
        payload.events = holidayArray
        await http.post(`${constants.API_URL}/api/academic-calendar/update-holiday-event`, payload)
        if (this.deleteEventDate) {
          await http.put(`${constants.API_URL}/api/holiday-event/delete?date=${this.deleteEventDate}&academicYearID=${this.academicCalendarData.academicYearID}&zoneID=${this.academicCalendarData.zoneID}&businessProgramMapID=${this.academicCalendarData.businessProgramMapID}`)
        }
        if (this.deleteHolidayIDs) {
          let obj = {
            holidayIds: this.deleteHolidayIDs
          }
          await http.put(`${constants.API_URL}/api/holiday/delete`, obj)
        }
        this.dialog = false
        await this.getHolidayName()
        this.okMsg('Holiday Saved successfully!')
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    deleteIndividualHoliday: async function (holidayID, index) {
      if (this.selectedDates) {
        let dateKeys = Object.keys(this.saveAllHolidayListName)
        this.selectedDates.forEach((item) => {
          if (dateKeys.indexOf(item) !== -1) {
            this.saveAllHolidayListName[item].selectedHoliday.splice(index, 1)
          }
        })
      }
      this.deleteHolidayIDs.push(holidayID)
    },
    deleteEvent: async function (holidayDate, index) {
      if (this.dateKey.indexOf(holidayDate) === -1) {
        this.isData = true
      } else {
        this.isData = false
      }
      if (this.isData) {
        this.selectedDates.splice(index, 1)
      } else if (!this.isData) {
        if (holidayDate) {
          this.deleteEventDate = holidayDate
          this.selectedDates.splice(index, 1)
        }
      }
    },
    // ******Calendar Edit Ends********
    enableButton: function () {
      if (this.startDate && this.toDate) {
        this.disabled = false
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }

  }
}
</script>
<style>
.selected-date {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.table-border {
  border-bottom: solid 1px #000
}

.table-border-right {
  border-right: solid 1px #000;
}

.table-header {
  width: 100%;
  text-align: center;
  color: #FFFFFF
}

.grey-bg {
  background-color: #C7C6C1;
}

.v-tooltip__content {
  pointer-events: initial;
}
</style>
